import React, {Fragment, useEffect, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import TableSection from "../../../../../components/sales/tableSection/tableSection";
import Layout from "../../../../../components/sales/layout/layout";
import {Button} from "react-bootstrap";
import Images from "../../../../../assets/images/imageData";
import Filter from "../Filter";
import {toast } from "react-toastify";
import ModalPop from 'components/sales/modal/modal';

const CapexInvoiceList = ({
    getCapexContractInvoice,
    capexContractInvoice=[],
    updateCapexStatus
}) => {
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [showFilter, setShowFilter] = useState(false);
    const [isRoleId, setIsRoleId] = useState('BUSINESS');
    const [isSuccessModel, setIsSuccessModel] = useState(false);

    useEffect(() => {
        (async () => {
            let role = window.localStorage.getItem("fusion-role");
            role = role == 13 || role == 49 ? 'FINANCE' : 'BUSINESS'
            setIsRoleId(role)
            setIsLoading(true)
            await getCapexContractInvoice(1, 1, {role: role})
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        'PI Number',
        'PI Date',
        'PI Link',
        "TI Number",
        'TI Date',
        'TI Link',
        'Business Name',
        'Client Name',
        'Site Number',
        'Status',
        'Actions'
    ];

    useEffect(() => {
        if (capexContractInvoice && capexContractInvoice?.resultSets && capexContractInvoice?.resultSets.length > 0) {
            const tableData = [
                'invoice_number', 
                'invoice_date',
                'pi_pdf_link',
                'ti_number', 
                'ti_date', 
                'ti_pdf_link',
                'business_name', 
                'client_name',
                'site_number', 
                'installment_status'
            ];

            const data = capexContractInvoice?.resultSets.map((element) => {
                let tiFinalDate = new Date(element.invoice_date);
                tiFinalDate.setDate(tiFinalDate.getDate() + (isRoleId === 'BUSINESS' ? 3 : 6));
                const mappedData = Object.assign(
                    ...tableData.map((key) => (
                        key === "pi_pdf_link" || key === "ti_pdf_link"
                        ? { 
                            [key]: element[key] ? (
                                <a
                                    href={element[key]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="btn btn-primary"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                        <path fillRule="evenodd"
                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
                                    </svg>
                                </a>
                            ) : ''
                        }
                        : { [key]: element[key] }
                    )),
                    {
                        CustomActions:[
                            (
                                isRoleId === 'BUSINESS' && tiFinalDate >= new Date() && element.business_approval_status === 1 && element.finance_approval_status === 1 && element.installment_status === 'PENDING' ? (
                                    <button
                                      className="btn btn-green-v1"
                                      onClick={() => handleApproveInvoice(element)}
                                    >
                                      {localization.convertToTI}
                                    </button>
                                  ) : null
                            ),
                            (
                                isRoleId === 'BUSINESS' && tiFinalDate >= new Date() && element.business_approval_status === 1 && element.finance_approval_status === 1 && element.installment_status === 'PENDING' ? (
                                    <button
                                      className="btn btn-red"
                                      onClick={() => handleRejectInvoice(element)}
                                    >
                                      {localization.requestCancellation}
                                    </button>
                                  ) : null
                            ),
                            (
                                isRoleId === 'BUSINESS' && tiFinalDate >= new Date() && element.business_approval_status === 3 && element.finance_approval_status === 1 ? (
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleWithdrawInvoice(element)}
                                    >
                                      {localization.withdrawRequest}
                                    </button>
                                  ) : null
                            ),
                            (
                                isRoleId === 'FINANCE' && tiFinalDate >= new Date() && element.finance_approval_status === 1 && element.business_approval_status === 1 ? (
                                    <button
                                      className="btn btn-green-v1"
                                      onClick={() => handleApproveInvoice(element)}
                                    >
                                      {localization.convertToTI}
                                    </button>
                                  ) : null
                            ),
                            (
                                isRoleId === 'FINANCE' && tiFinalDate >= new Date() && element.finance_approval_status === 1 && element.business_approval_status === 3 ? (
                                    <button
                                      className="btn btn-green-v1"
                                      onClick={() => handleApproveInvoice(element)}
                                    >
                                      {localization.rejectRequest}
                                    </button>
                                  ) : null
                            ),
                            (
                                isRoleId === 'FINANCE' && tiFinalDate >= new Date() && element.finance_approval_status === 1 && element.business_approval_status === 3 ? (
                                    <button
                                      className="btn btn-red"
                                      onClick={() => handleRejectInvoice(element)}
                                    >
                                      {localization.cancelTiConversion}
                                    </button>
                                  ) : null
                            )
                        ]
                    },
                ); 
    
                return {...mappedData};
            });
    
            if (data) {
                setListData(data);
            }

            setPageCount(Math.ceil(capexContractInvoice.total / capexContractInvoice.per_page));
        }
    }, [capexContractInvoice]);
    

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getCapexContractInvoice(val.selected + 1, 2);
        setIsLoading(false);
    };

    const applyFilter = async (filterData) => {
        const { from_pi_date, to_pi_date } = filterData;

        if ((from_pi_date && !to_pi_date) || (!from_pi_date && to_pi_date)) {
            toast.error("Please select both From PI Date and To PI Date.");
            return false;
        }

        setIsLoading(true);
        localStorage.setItem("service_invoice", JSON.stringify(filterData));
        await getCapexContractInvoice(1, 2, filterData);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>
                </Fragment>
            </>
        );
    };

    const handleApproveInvoice = (val) => {
        let approvalRequest = {
            invoice_id: val.invoice_id,
            action: 2,
            role: isRoleId
        };
        (async () => {
            setIsLoading(true);
            const res = await updateCapexStatus(approvalRequest);
            setIsLoading(false);
            if(res == true) {
                setIsSuccessModel(true);
            }
        })();
    }

    const handleRejectInvoice = (val) => {
        let rejectRequest = {
            invoice_id: val.invoice_id,
            action: 3,
            role: isRoleId
        };
        (async () => {
            setIsLoading(true);
            const res = await updateCapexStatus(rejectRequest);
            if(res == true) {
                setIsLoading(false);
                setIsSuccessModel(true);
            } else {
              setIsLoading(false);
              toast.error('Error in reject invoice');
            }
        })();
    }

    const handleWithdrawInvoice = (val) => {
        let rejectRequest = {
            invoice_id: val.invoice_id,
            action: 1,
            role: isRoleId
        };
        (async () => {
            setIsLoading(true);
            const res = await updateCapexStatus(rejectRequest);
            if(res == true) {
                setIsLoading(false);
                setIsSuccessModel(true);
            } else {
              setIsLoading(false);
              toast.error('Error in withdraw invoice');
            }
        })();
    }

    const handleRejectModalHide =  async () => {
        setIsSuccessModel(false);
        setIsLoading(true)
        await getCapexContractInvoice(1, 1, {role: isRoleId})
        setIsLoading(false)
    }

    const successIconBox = (text, func) => {
        return (
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{text}</h5>
            <button onClick={handleRejectModalHide} className='btn btn-primary btn-sm text-center'>Close</button>
          </div>
        );
    };

    return (
        <>
            <Layout
                title={'Capex Invoice'}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={capexContractInvoice && capexContractInvoice.resultSets}
                    srNo={capexContractInvoice?.from}
                />
            </Layout>

            <Filter
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
            />

            <ModalPop
                title={localization.success}
                show={isSuccessModel}
                handleModalHide={handleRejectModalHide}
            >
                {successIconBox(localization.updatedSuccessfully, handleRejectModalHide)}
            </ModalPop>

        </>
    )
}

export default CapexInvoiceList